/* ==========================================================================
   ATÖLYE — usta yolu kaydırma motoru

   Neden GSAP + ScrollTrigger değil:
   Bu sayfanın ihtiyacı üç şey — koşu boyunca 0..1 ilerleme (iplik), aşama
   başına geçilme oranı (giden aşamanın geride kalması), ve aktif aşama işareti
   (delik açılması). Üçü de birkaç satır. ScrollTrigger ~70 KB'lık bir yük
   getirir ve yüklenene kadar etki başlamaz; lüks, ziyaretçiye kütüphane
   indirtmek değil. Yığılma zaten position:sticky ile CSS'te — pin taklidi yok.

   Bütçe: tek rAF döngüsü, yalnızca bölüm ekranda ve sekme öndeyken koşar.
   ========================================================================== */

(() => {
  const SEL = "[data-atl-craft]";
  const azalt = window.matchMedia("(prefers-reduced-motion: reduce)");

  const kur = (bolum) => {
    if (bolum.dataset.atlReady === "1") return;
    bolum.dataset.atlReady = "1";

    const kosu = bolum.querySelector(".atl-craft__run");
    const asamalar = [...bolum.querySelectorAll("[data-atl-stage]")];
    const delikler = [...bolum.querySelectorAll(".atl-craft__hole")];
    if (!kosu || !asamalar.length) return;

    let gorunur = false;
    let bekleyen = false;
    let sonAktif = -1;

    const sinirla = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);

    const olc = () => {
      bekleyen = false;
      const kutu = kosu.getBoundingClientRect();
      const vh = window.innerHeight || 1;

      // Koşunun içinde ne kadar ilerledik. Yığılmış sticky düzende her aşama
      // bir ekran boyu sürer, dolayısıyla kaydırma miktarı doğrudan aşama
      // indeksine çevrilir.
      const kaydirilan = Math.max(0, -kutu.top);
      const toplam = Math.max(1, kutu.height - vh);
      bolum.style.setProperty("--atl-progress", sinirla(kaydirilan / toplam).toFixed(4));

      // Mobilde aşamalar statik akar; "giden aşama" diye bir şey yok, ölçek
      // yazmak boşa iş olur (CSS de yok sayıyor).
      const yigili = getComputedStyle(asamalar[0]).position === "sticky";

      let aktif;
      if (yigili) {
        // Her aşama bir ekran boyu sürdüğü için aktif indeks doğrudan bölme.
        aktif = Math.min(asamalar.length - 1, Math.floor(kaydirilan / vh));
        asamalar.forEach((el, i) => {
          const p = sinirla((kaydirilan - i * vh) / vh);
          el.style.setProperty("--p", p.toFixed(4));
          // Bir sonraki aşamaya "sen ne kadar geldin" bilgisini geçir. Kendi --p'si
          // 0 olduğu için gelen aşama kendi varışını bilemez; onu önceki söyler.
          // Metni buna bağlıyoruz: geçiş sırasında iki metin aynı anda okunmasın.
          if (asamalar[i + 1]) asamalar[i + 1].style.setProperty("--gelis", p.toFixed(4));
        });
      } else {
        // Statik akışta aktif aşama, ekranın ortasına en yakın olandır.
        let enIyi = Infinity;
        aktif = 0;
        asamalar.forEach((el, i) => {
          const r = el.getBoundingClientRect();
          const uzaklik = Math.abs(r.top + r.height / 2 - vh / 2);
          if (uzaklik < enIyi) {
            enIyi = uzaklik;
            aktif = i;
          }
        });
      }

      if (aktif !== sonAktif) {
        sonAktif = aktif;
        asamalar.forEach((el, i) => el.classList.toggle("is-active", i === aktif));
        // Delik, aşaması geldiğinde açılır ve açık kalır: biz geri alınmaz.
        delikler.forEach((d, i) => {
          if (i <= aktif) d.classList.add("is-punched");
        });
      }
    };

    const istek = () => {
      if (bekleyen || !gorunur) return;
      bekleyen = true;
      requestAnimationFrame(olc);
    };

    // Bölüm ekran dışındayken hiç ölçmüyoruz. Sayfada başka bölümler de var.
    new IntersectionObserver(
      (girisler) => {
        gorunur = girisler.some((g) => g.isIntersecting);
        if (gorunur) istek();
      },
      { rootMargin: "20% 0px" }
    ).observe(kosu);

    if (azalt.matches) {
      // Hareket azaltma: sürekli ölçüm yok. Dikiş tam çizili, delikler açık.
      bolum.style.setProperty("--atl-progress", "1");
      delikler.forEach((d) => d.classList.add("is-punched"));
      asamalar.forEach((el) => el.style.setProperty("--p", "0"));
      asamalar[0].classList.add("is-active");
      return;
    }

    addEventListener("scroll", istek, { passive: true });
    addEventListener("resize", istek, { passive: true });
    // Yazı tipleri geldiğinde yükseklikler değişir; yeniden ölç.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(istek);
    gorunur = true;
    olc();
  };

  const baslat = () => document.querySelectorAll(SEL).forEach(kur);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", baslat, { once: true });
  } else {
    baslat();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const el = e.target.querySelector ? e.target.querySelector(SEL) : null;
    if (el) kur(el);
  });
})();
